import Vue from "vue";
import { Component } from "vue-property-decorator";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import $ from "jquery";
import { EventBus } from "../Controls/EventBus";
import { ParametresInstance } from "../Controls/Parameters";
import { FavoriDto } from "../../dto/GenApi.iNotPaie.Dto/FavoriDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ModalAlerteOptions } from "../modalComponents/modalAlerte/modalAlerte";
import { ModalEnvoiBulletinOptions } from "../modalComponents/modalEnvoiBulletin/modalEnvoiBulletin";
import { CategorieHead, MenuChild, menuModel, Role, TypeAction, TypeCondition } from "./menu.model";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { LicensingManagerInstance } from "../Controls/LicensingManager";
import { License } from "../../shared/Enums/Licensing/License";
import { FeatureFlagManagerInstance } from "../Controls/FeatureFlagManager";
import { FeatureFlagModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagModuleEnum";

@Component
export default class MenuComponent extends Vue {
	public favoris: FavoriDto[] = [];
	public paieEnable = false;
	public isModDemarrage = false;
	public modePst = false;
	public possedeReglementSepa = false;
	public typeAction = TypeAction;
	public disableFav = false;

	public menuModel = menuModel;

	public mounted(): void {
		EventBus.$on(EventConstants.UTILISATEUR_CHANGED, () => {
			this.updateFavoris();

			this.$forceUpdate();
		});

		this.updateFavoris();

		EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
			this.updateRoles();
		});

		this.updateRoles();
		$(function() {
			const timeSlide = 350;
			$(document).on("click", ".toggle", function(e: any) {
				e.preventDefault();

				const $this = $(e.currentTarget);

				if (!$this.hasClass("empty")) {
					if ($this.hasClass("active")) {
						$this.removeClass("active");
						$this.next().stop().slideUp(timeSlide);
					} else {
						$this.parent().parent().find("li .active").next().slideUp(timeSlide);
						$this.parent().parent().find("li .toggle").removeClass("active");
						$this.addClass("active");
						$this.next().stop().slideDown(timeSlide);
					}
				}
			});

			$(".overlay").click(function() {
				resetMenu();
			});
			$(".btn-toggleMenu").click(function() {
				resetMenu();
			});
			$(".menu-main li ul li").click(function() {
				resetMenu();
			});

			function resetMenu(): void {
				const mainMenu = $(".menu-main");
				mainMenu.find("li .active").next().stop().slideUp(timeSlide);
				mainMenu.find("li .active").removeClass("active");
			}
		});
	}

	private resetMenu(): void {
		const mainMenu = $(".menu-main");
		mainMenu.find("li .active").next().stop().slideUp(350);
		mainMenu.find("li .active").removeClass("active");
	}

	public isVisible(path: string): boolean {
		if (ParametresInstance.utilisateurCourant == undefined) {
			return false;
		}
		if (ParametresInstance.utilisateurCourant.Roles == undefined) {
			return false;
		}
		if (path == undefined) {
			return false;
		}
		const routes = this.$router.resolve(path);
		if (routes != undefined && routes.route.meta != undefined && routes.route.meta.roles != undefined) {
			return ParametresInstance.userIsAuthorized(routes.route.meta.roles) && this.paieEnable;
		}

		return false;
	}

	public isSalarie(): any {
		return ParametresInstance.userHasRole(RoleConstants.Salarie);
	}

	public isModeConge(): any {
		if (ParametresInstance.societeCourante == undefined) {
			return;
		}

		return ParametresInstance.societeCourante.IsModeCongeActive;
	}

	public hasRole(role: string): boolean {
		return ParametresInstance.userIsAuthorized([role]);
	}

	public hasArrayRole(roles: Role[]): boolean {
		if (roles.length === 0) {
			return true;
		}

		return ParametresInstance.userIsAuthorized(roles);
	}

	public hasCombinedRolesAuthorize(roles: Role[]): boolean {
		if (roles.length === 0) {
			return false;
		}

		return ParametresInstance.userIsCombinedAuthorized(roles);
	}

	public hasLicense(license?: License): boolean {
		if (license == undefined) {
			return true;
		}

		return LicensingManagerInstance.hasLicense(license);
	}

	public hasFeatureFlag(featureFlag?: FeatureFlagModuleEnum): boolean {
		if (featureFlag == undefined) {
			return false;
		}

		return FeatureFlagManagerInstance.hasFeatureFlag(featureFlag);
	}

	public toggleStateModeMenu(): void {
		this.$emit("toggleMenu", "");
		$(this).toggleClass("open");
	}

	public openTab(path: string): void {
		EventBus.NavigateTo({ path: path });
		this.$emit("toggleMenu", "");
	}

	public openmodalCloturePaie(): void {
		this.$emit("toggleMenu", "");

		if (this.isModDemarrage) {
			const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
				message: "Vous ne pouvez pas clôturer de paie quand le mode démarrage est activé"
			});
			EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
		} else {
			EventBus.$emit(EventConstants.MODAL_CLOTURE_PAIE);
		}
	}

	public openmodalVirementSepa(): void {
		this.$emit("toggleMenu", "");

		if (this.isModDemarrage) {
			const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
				message: "Vous ne pouvez pas effectuer vos virements SEPA quand le mode démarrage est activé"
			});
			EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
		} else {
			EventBus.$emit(EventConstants.MODAL_VIREMENT_SEPA);
		}
	}

	public openmodalDevalidationClotureExercice(): void {
		this.$emit("toggleMenu", "");

		if (this.isModDemarrage) {
			const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
				message: "Vous ne pouvez pas dévalider une clôture d'exercice quand le mode démarrage est activé"
			});
			EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
		} else {
			EventBus.$emit(EventConstants.MODAL_DEVALIDATION_CLOTURE_EXERCICE);
		}
	}

	public openUrl(url: string): void {
		window.open(url, "_blank");
	}

	public envoyeBulletins(): void {
		this.$emit("toggleMenu", "");

		const modalOptions: ModalEnvoiBulletinOptions = new ModalEnvoiBulletinOptions({
			message: "Envoyer les bulletins de la dernière période clôturée par mail ?"
		});

		EventBus.$emit(EventConstants.MODAL_ENVOI_BULLETIN, modalOptions);
	}

	public openModalImporterTopaze(): void {
		this.$emit("toggleMenu", "");
		EventBus.$emit(EventConstants.MODAL_IMPORTER_TOPAZE);
	}

	public editionFinDeMois(): void {
		this.$emit("toggleMenu", "");
		EventBus.$emit(EventConstants.MODAL_EDITION_FIN_DE_MOIS);
	}

	public editionFinDeMoisCumulees(): void {
		this.$emit("toggleMenu", "");
		EventBus.$emit(EventConstants.MODAL_EDITION_FIN_DE_MOIS_CUMULEES);
	}

	public reeditionBulletins(): void {
		this.$emit("toggleMenu", "");
		EventBus.$emit(EventConstants.MODAL_REEDITION_BULLETINS);
	}

	/** ************* Favorite part ***************/
	public isFavorite(key: string): boolean {
		return this.paieEnable && this.favoris.filter(f => f.Key == key).length > 0;
	}

	public execFavorite(key: string): void {
		if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur != undefined) {
			const favorisFiltered = ParametresInstance.utilisateurCourant.ProfilUtilisateur.Favoris.filter(f => f.Key === key);
			if (favorisFiltered.length == 1) {
				const favoris = favorisFiltered[0];

				if (favoris.FunctionName != undefined) {
					this[favoris.FunctionName](favoris.Param);
				}
			} else {
				NotificationServiceInstance.SendFailed("Plusieurs favoris avec la même clé trouvés");
			}
		}
	}

	public toggleFav(item: MenuChild, categorie: CategorieHead, isAdd: boolean, event: any): void {
		event.stopPropagation();
		event.preventDefault();

		if (this.disableFav) {
			return;
		}

		this.disableFav = true;

		if (isAdd) {
			this.addFavorite(item, categorie);
		} else {
			this.removeFavorite(item.id, item.name, false, event);
		}
	}

	public addFavorite(item: MenuChild, categorie: CategorieHead): void {
		this.favoris.push({
			Libelle: categorie.id + " - " + item.name,
			Key: item.id,
			FunctionName: item.typeAction,
			Param: item.path
		});

		this.updateProfilUtilisateur(true, item.name);
	}

	public removeFavorite(itemId: string, itemName: string, isFavTab: boolean, event: any): void {
		event.stopPropagation();
		event.preventDefault();

		if (isFavTab && this.favoris.length > 1) {
			this.animHeightFav();
		}

		this.favoris = this.favoris.filter(f => f.Key != itemId);

		if (isFavTab && this.favoris.length === 0) {
			const favLi = <HTMLDivElement> this.$refs.favLi;
			$(favLi).click();
		}

		this.updateProfilUtilisateur(false, itemName);
	}

	private animHeightFav(): void {
		const innerFav = <HTMLDivElement> this.$refs.innerFav;
		const el = $(innerFav);
		const curHeight = el.height();
		const resultHeight = curHeight - 40;

		el.height(curHeight).animate({ height: resultHeight + "px" }, 350, function() {
			el.css("height", "auto");
		});
	}

	private updateProfilUtilisateur(isAdd: boolean, itemName: string): void {
		if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur != undefined) {
			ParametresInstance.utilisateurCourant.ProfilUtilisateur.Favoris = this.favoris;

			ServicesFactoryInstance.UtilisateurService.updateProfil(ParametresInstance.utilisateurCourant.ProfilUtilisateur, () => {
				this.disableFav = false;
				NotificationServiceInstance.SendSuccess("Le favori \"<strong>" + itemName + "</strong>\" a bien été " + (isAdd ? "ajouté" : "supprimé") + ".");
			});
		}
	}

	public openAction(child: MenuChild): void {
		switch (child.typeAction) {
			case TypeAction.openTab:
				this.openTab(child.path);
				break;
			case TypeAction.openModal:
				this.openTab(child.path);
				break;
			case TypeAction.openmodalCloturePaie:
				this.openmodalCloturePaie();
				break;
			case TypeAction.openmodalDevalidationClotureExercice:
				this.openmodalDevalidationClotureExercice();
				break;
			case TypeAction.editionFinDeMois:
				this.editionFinDeMois();
				break;
			case TypeAction.openmodalVirementSepa:
				this.openmodalVirementSepa();
				break;
			case TypeAction.editionFinDeMoisCumulees:
				this.editionFinDeMoisCumulees();
				break;
			case TypeAction.envoyeBulletins:
				this.envoyeBulletins();
				break;
			case TypeAction.reeditionBulletins:
				this.reeditionBulletins();
				break;
			case TypeAction.openModalImporterTopaze:
				this.openModalImporterTopaze();
				break;
			case TypeAction.openUrl:
				this.openUrl(child.path);
				break;
		}

		this.resetMenu();
	}

	public canShow(element: CategorieHead | MenuChild): boolean {
		const authorizedRoles = element.authorizedRoles;
		const conditions = element.typeCondition;
		let child: MenuChild | null = null;

		if (conditions.length === 0) {
			return true;
		}

		if (element as MenuChild) {
			child = element as MenuChild;
		}

		for (let i = 0; i < conditions.length; i++) {
			switch (conditions[i]) {
				case TypeCondition.isVisible:
					if (child && !this.isVisible(child.path)) {
						return false;
					}
					break;
				case TypeCondition.hasRole:
					if (child?.isCombinedRoles && !this.hasCombinedRolesAuthorize(authorizedRoles)) {
						return false;
					} else if (!this.hasArrayRole(authorizedRoles)) {
						return false;
					}
					break;
				case TypeCondition.paieEnable:
					if (!this.paieEnable) {
						return false;
					}
					break;
				case TypeCondition.paieNotEnable:
					if (this.paieEnable) {
						return false;
					}
					break;
				case TypeCondition.isSalarie:
					if (!this.isSalarie()) {
						return false;
					}
					break;
				case TypeCondition.isModeConge:
					if (!this.isModeConge()) {
						return false;
					}
					break;
				case TypeCondition.modePst:
					if (!this.modePst) {
						return false;
					}
					break;
				case TypeCondition.possedeReglementSepa:
					if (!this.possedeReglementSepa) {
						return false;
					}
					break;
				case TypeCondition.hasLicense:
					if (child && !this.hasLicense(child.authorizedLicense)) {
						return false;
					}
					break;
				case TypeCondition.doNotHaveLicense:
					if (child && this.hasLicense(child?.authorizedLicense)) {
						return false;
					}
					break;
				case TypeCondition.hasFeatureFlag:
					if (child && !this.hasFeatureFlag(child.authorizedFeatureFlag)) {
						return false;
					}
					break;
			}
		}

		return true;
	}

	// Mise à jour des favoris
	private updateFavoris(): void {
		if (ParametresInstance.utilisateurCourant && ParametresInstance.utilisateurCourant.ProfilUtilisateur && ParametresInstance.utilisateurCourant.ProfilUtilisateur.Favoris) {
			this.favoris = ParametresInstance.utilisateurCourant.ProfilUtilisateur.Favoris;
		}
	}

	// Mise à jour des rôles
	private updateRoles(): void {
		this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
		this.modePst = ParametresInstance.isPst;
		this.isModDemarrage = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsModDemarrage);
		this.possedeReglementSepa = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.PossedeReglementSepa);
	}
}




// WEBPACK FOOTER //
// ./src/components/menu/menu.ts